import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=16d1a3dc&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=16d1a3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1a3dc",
  null
  
)

export default component.exports